export class SelectedCircleOptions {
    radius: any = 42;
    color: any = '#ffffff';
    opacity: any = 0.3;
    strokeWidth: any = 2;
    strokeOpacity: any = 0.75;
    strokeColor: any = '#ffffff';
}
